import _ from 'lodash';

export const convertToCoordinates = (data, type) => {
    return data.map(str => {
    // 将每一条字符串按分号分割
        const points = str.split(';').map(coord => {
            const [longitude, latitude] = coord.split(',').map(Number);
            return { longitude, latitude };
        });
        return { points, color: '#2bb12b', type };
    });
};

export const transformTrackingData = (data) => {
    return [{
        points: data.map(item => ({
            longitude: parseFloat(item.longitude),
            latitude: parseFloat(item.latitude)
        })),
        color: '#1E90FF'
    }];
};

export const formateData = (data) => {
    const list = _.cloneDeep(data);
    list.forEach(item => {
        item.indexName = item.unloadSequenceAmap + 1;
        item.pointName = item.unloadSequenceAmap === 0 ? '发货点' : `卸货点${item.unloadSequenceAmap}`;
        item.pointTitle = item.unloadSequenceAmap === 0 ? '发' : `卸${item.unloadSequenceAmap}`;
    });
    return list;
};

export const formateList = (data, dictData) => {
    const list = _.cloneDeep(data);
    list.forEach((item, index) => {
        item.indexName = index + 1;
        item.warningTypeName = t(item.warningType, dictData, 'CHANGE_MONITOR_WARNING_TYPE'); // 预警类型
        item.virtualDialStatusName = t(item.virtualDialStatus, dictData, 'DISPATCH_VIRTUAL_DIAL_STATUS'); // 智能拨号状态
        item.earlyWarningGradeName = t(item.earlyWarningGrade, dictData, 'BUNCH_GOODS_EARLY_WARNING_GRADE'); // 预警等级
    });
    return list;
};

export const formatTotalDataList = (data) => {
    if (!data.length) return [];
    data.forEach(e => {
        e.isAbnormalName = e.isAbnormal === '0' ? '正常' : e.isAbnormal ? '异常' : '';
        e.speedName = e.speed + 'km/h';
    });
    return data;
};

const t = (key, dict, dicType) => {
    if (key === undefined || key === null) return '';
    if (!dict[dicType]) return key;
    return dict[dicType][key + ''] || key;
};

export const outputArray = (inputObject) => Object.entries(inputObject).map(([key, val]) => {
    return { label: val, value: key };
});